import moment from "moment";

export const customMultiSelectStyles = {
    control: (provided) => ({
        ...provided,
        maxHeight: "100px",
        overflowY: "auto",
    }),
    menu: (provided) => ({
        ...provided,
        maxHeight: "200px",
        overflowY: "auto",
    }),
    menuList: (provided) => ({
        ...provided,
        maxHeight: "200px",
        overflowY: "auto",
    }),
};

export const normalizeTimeToMinutes = (time) => {
    if (!time || typeof time !== "string") return null;
    const parts = time.split(":");
    if (parts.length < 2) return null;
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    return hours * 60 + minutes;
};

export const toApiTime = (time) => {
    if (!time) return time;
    const parts = time.split(":");
    return parts.length === 2 ? `${time}:00` : time;
};

export const fromApiTime = (time) => {
    if (!time) return "";
    const parts = String(time).split(":");
    return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : String(time);
};

export const parseApiDate = (date) => {
    if (!date) return "";
    const parsed = moment(date);
    return parsed.isValid() ? parsed.toDate() : "";
};

export const parseEventUserDiv = (eventUserDiv) => {
    if (!eventUserDiv || eventUserDiv === "0" || parseInt(eventUserDiv) === 0) {
        return ["0"];
    }
    return String(eventUserDiv).split(",").map((id) => String(id).trim()).filter(Boolean);
};

export const isRegistrationPeriodOpen = (registrationStartDate, registrationEndDate) => {
    if (!registrationStartDate || !registrationEndDate) return false;
    const today = moment().startOf("day");
    const start = moment(registrationStartDate).startOf("day");
    const end = moment(registrationEndDate).startOf("day");
    if (!start.isValid() || !end.isValid()) return false;
    return today.isSameOrAfter(start) && today.isSameOrBefore(end);
};

export const hasEventAttendanceStarted = (eventStartDate, eventStartTime) => {
    if (!eventStartDate) return false;
    if (!eventStartTime) {
        return moment().startOf("day").isSameOrAfter(moment(eventStartDate).startOf("day"));
    }
    const eventStart = moment(`${eventStartDate} ${eventStartTime}`, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"], true);
    if (!eventStart.isValid()) {
        return moment().startOf("day").isSameOrAfter(moment(eventStartDate).startOf("day"));
    }
    return moment().isSameOrAfter(eventStart);
};

export const canShowDivisionRegisterButton = (item, roleSlug) => {
    const isDivLeader = roleSlug === "captain" || roleSlug === "div_admin";
    if (!isDivLeader || item.event_mode !== "division_registration") return false;
    if (!isRegistrationPeriodOpen(item.registration_start_date, item.registration_end_date)) return false;
    if (hasEventAttendanceStarted(item.event_start_date, item.event_start_time)) return false;
    return true;
};

export const validateDivisionRegistrationForm = (values) => {
    const errors = {};
    if (parseInt(values.event_organization) < 1) errors.event_organization = "Organization is required";
    if (!values.event_user_div || values.event_user_div.length < 1) {
        errors.event_user_div = "Please select at least one division";
    }
    if (!values.event_title) errors.event_title = "Event title is required";
    if (!values.registration_start_date) errors.registration_start_date = "Registration start date is required";
    if (!values.registration_end_date) errors.registration_end_date = "Registration end date is required";
    if (!values.event_start_date) errors.event_start_date = "Attendance start date is required";
    if (!values.event_end_date) errors.event_end_date = "Attendance end date is required";
    if (!values.event_start_time) errors.event_start_time = "Daily start time is required";
    if (!values.attendence_time) errors.attendence_time = "Daily attendance end time is required";
    if (!values.event_description) errors.event_description = "Description is required";
    if (!values.event_location) errors.event_location = "Location is required";
    if (values.registration_start_date && values.registration_end_date && moment(values.registration_end_date).isBefore(values.registration_start_date, "day")) {
        errors.registration_end_date = "Registration end must be after start";
    }
    if (values.event_start_date && values.event_end_date && moment(values.event_end_date).isBefore(values.event_start_date, "day")) {
        errors.event_end_date = "Attendance end must be after start";
    }
    if (values.registration_end_date && values.event_start_date && moment(values.registration_end_date).isAfter(values.event_start_date, "day")) {
        errors.registration_end_date = "Registration must end before attendance starts";
    }
    const startMinutes = normalizeTimeToMinutes(values.event_start_time);
    const endMinutes = normalizeTimeToMinutes(values.attendence_time);
    if (startMinutes !== null && endMinutes !== null && endMinutes <= startMinutes) {
        errors.attendence_time = "Attendance end time must be after start time";
    }
    return errors;
};

export const buildDivisionRegistrationPayload = (values, eventId = null) => {
    const payload = {
        event_organization: values.event_organization,
        event_user_div: values.event_user_div.includes("0") ? "0" : values.event_user_div.join(","),
        event_title: values.event_title,
        registration_start_date: moment(values.registration_start_date).format("YYYY-MM-DD"),
        registration_end_date: moment(values.registration_end_date).format("YYYY-MM-DD"),
        event_start_date: moment(values.event_start_date).format("YYYY-MM-DD"),
        event_end_date: moment(values.event_end_date).format("YYYY-MM-DD"),
        event_start_time: toApiTime(values.event_start_time),
        attendence_time: toApiTime(values.attendence_time),
        event_end_time: toApiTime(values.attendence_time),
        event_description: values.event_description,
        event_location: values.event_location,
    };
    if (eventId) payload.event_id = eventId;
    return payload;
};
